import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import StandardPagination from "../../../components/pagination/StandardPagination.vue";
import ActionButtons from "../../../components/actions/ActionButtons.vue";
import { EmpenhoService } from "../../../services/EmpenhoService";
import { SnackBarModule } from "../../../modules/SnackBarModule";

export default {
  name: "GerenciarEmpenhos",
  components: {
    Breadcrumb,
    StandardPagination,
    ActionButtons
  },
  data: () => ({
    breadcrumbs: [
      {
        text: 'Página Inicial',
        disabled: false,
        href: '/',
      },
      {
        text: 'Processos de Compras',
        disabled: false,
        href: '/gerenciar-processos-compras',
      },
      {
        text: 'Gerenciar Empenho',
        disabled: true
      }
    ],
    headers: [
      { text: 'Número do Empenho', align: 'center', value: 'numero_empenho_completo', sortable: true },
      { text: 'Ano Empenho', align: 'center', value: 'ano_empenho', sortable: true },
      { text: 'Número do Processo', align: 'center', value: 'numero_processo_formatado', sortable: true },
      { text: 'CNPJ/CPF Fornecedor', align: 'center', value: 'cnpj_cpf_fornecedor', sortable: true },
      { text: 'Nome Fornecedor', align: 'center', value: 'nome_fornecedor', sortable: true },
      { text: 'Valor Total do Empenho', align: 'center', value: 'empenho_valor_total', sortable: true },
    ],
    filters: {
      anoEmpenho: '',
      numeroEmpenho: '',
      processo: '',
      cnpjCpfFornecedor: '',
      unidade: '',
    },
    anoOptions: [],
    items: [],
    itemSelected: [],
    page: 1,
    totalItems: 0,
    itemsPerPage: 10,
    itemsPerPageOptions: [10, 20, 50, 100],
    showFilters: true
  }),
  created() {
    this.generateAnoOptions();
    this.listarEmpenhosPaginado();
  },
  watch: {
    page: async function(newValue) {
      this.page = newValue;
      await this.listarEmpenhosPaginado();
    },
    itemSelected: {
      handler(newVal) {
        if (newVal.length > 1) {
          this.itemSelected = [newVal[newVal.length - 1]];
          SnackBarModule('Apenas um registro pode ser selecionado por vez para visualização.', 'warning');
        }
      },
      deep: true
    },
    'filters.anoEmpenho': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.listarEmpenhosPaginado();
      }
    },
    'filters.numeroEmpenho': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.listarEmpenhosPaginado();
      }
    },
    'filters.processo': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.listarEmpenhosPaginado();
      }
    },
    'filters.cnpjCpfFornecedor': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.listarEmpenhosPaginado();
      }
    },
    'filters.unidade': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.listarEmpenhosPaginado();
      }
    },
  },
  computed: {
    computedHeaders() {
      return this.headers;
    },
    isAllSelected() {
      return this.items.length > 0 && this.itemSelected.length === this.items.length;
    },
    isIndeterminate() {
      return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
    }
  },
  methods: {
    generateAnoOptions() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let i = currentYear; i >= currentYear - 10; i--) {
        years.push(i.toString());
      }
      this.anoOptions = years;
    },
    toggleFilters() {
      this.showFilters = !this.showFilters;
    },
    clearFilters() {
      this.filters = {
        anoEmpenho: '',
        numeroEmpenho: '',
        processo: '',
        cnpjCpfFornecedor: '',
        unidade: '',
      };
      this.page = 1;
      this.listarEmpenhosPaginado();
    },
    toggleSelectAll() {
      if (this.isAllSelected) {
        this.itemSelected = [];
      } else {
        this.itemSelected = [...this.items];
      }
    },
    getRowClass(item) {
      return item.id % 2 === 0 ? 'even-row' : 'odd-row';
    },
    truncateText(text, maxLength) {
      if (!text) return '-';
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    },
    formatCurrency(value) {
      if (!value) return 'R$ 0,00';
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(value);
    },
    formatDate(date) {
      if (!date) return '-';
      return new Date(date).toLocaleDateString('pt-BR');
    },
    handleVisualizarDetalhe(item) {
      this.$router.push(`/empenhos/visualizar/${item.id}`);
    },
    getNumeroEmpenhoCompleto(item) {
      if (item.numero_empenho && item.codigo_unidade_contabil_executora && item.ano_empenho) {
        return `${item.codigo_unidade_contabil_executora}-${item.numero_empenho}/${item.ano_empenho}`;
      }
      if (item.numero_empenho && item.codigo_unidade_contabil_executora) {
        return `${item.codigo_unidade_contabil_executora}-${item.numero_empenho}`;
      }
      return item.numero_empenho || '-';
    },
    formatCnpjCpf(value) {
      if (!value) return '-';
      const cleaned = value.replace(/\D/g, '');
      if (cleaned.length === 11) {
        return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      } else if (cleaned.length === 14) {
        return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      }
      return value;
    },
    handlePageChange(newPage) {
      this.page = newPage;
      this.listarEmpenhosPaginado();
    },
    handleItemsPerPageChange(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
      this.page = 1;
      this.listarEmpenhosPaginado();
    },
    async listarEmpenhosPaginado() {
      try {
        const filter = this.prepareFormFilter();
        const response = await EmpenhoService.index(filter);

        if (typeof response !== 'string' && response && response.data) {
          this.items = response.data.data.map(item => ({
            ...item,
            numero_empenho_completo: this.getNumeroEmpenhoCompleto(item),
            cnpj_cpf_fornecedor: this.formatCnpjCpf(item.cnpj_cpf_fornecedor)
          }));
          this.totalItems = response.data.total;
          this.itemSelected = [];
          this.$forceUpdate();
        } else {
          console.error('Não foi possível obter os empenhos.');
        }
      } catch (error) {
        console.error('Ocorreu um erro ao listar os empenhos:', error);
      }
    },
    handleVisualizarEmpenho() {
      if (this.itemSelected.length === 0) {
        SnackBarModule('Selecione um registro para visualizar.', 'error');
        return;
      }
      
      if (this.itemSelected.length > 1) {
        SnackBarModule('Selecione apenas um registro para visualizar.', 'error');
        this.itemSelected = [this.itemSelected[0]];
        return;
      }
      
      this.$router.push(`/empenhos/visualizar/${this.itemSelected[0].id}`);
    },
    handleExportar() {
      this.$globalAlert('Não implementado!');
    },
    async destroyEmpenhos() {
      try {
        const ids = this.itemSelected.map(empenho => empenho.id);
        const formData = new FormData();

        ids.forEach(id => formData.append("empenhos[]", id));

        const response = await EmpenhoService.destroy(formData);

        if (!response) {
          console.error('Não foi possível excluir os empenhos.');
        }

        this.listarEmpenhosPaginado();
      } catch (error) {
        console.error('Ocorreu um erro ao excluir os empenhos:', error);
      }
    },
    prepareFormFilter() {
      const filter = new FormData();
      filter.append("page", this.page);
      filter.append("items_per_page", this.itemsPerPage);

      if (this.filters.anoEmpenho) {
        filter.append("ano_empenho", this.filters.anoEmpenho);
      }
      if (this.filters.numeroEmpenho) {
        filter.append("numero_empenho", this.filters.numeroEmpenho);
      }
      if (this.filters.processo) {
        filter.append("processo", this.filters.processo);
      }
      if (this.filters.cnpjCpfFornecedor) {
        filter.append("cnpj_cpf_fornecedor", this.filters.cnpjCpfFornecedor);
      }
      if (this.filters.unidade) {
        filter.append("unidade", this.filters.unidade);
      }

      return filter;
    }
  }
};
